class CollectionFilterComponent extends HTMLElement {
  constructor() {
    super();
    this.countElement = this.querySelector('[ref="collectionCount"]');
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.statusElement = this.querySelector('[ref="facetStatus"]');
    this.form = this.closest('form');
    this.updateCount();
    
    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.updateCount();
        this.handleFilterChange(e);
      });
    });
  }
  
  updateCount() {
    const checkedInputs = this.querySelectorAll('input[type="checkbox"]:checked');
    if (this.countElement) {
      this.countElement.textContent = checkedInputs.length;
    }
    
    // Show/hide the status based on whether any collections are selected
    if (this.statusElement) {
      if (checkedInputs.length > 0) {
        this.statusElement.style.display = 'inline-flex';
      } else {
        this.statusElement.style.display = 'none';
      }
    }
  }
  
  handleFilterChange(event) {
    // Get all checked collection inputs
    const checkedInputs = this.querySelectorAll('input[type="checkbox"]:checked');
    const selectedCollections = Array.from(checkedInputs).map(input => input.value);
    
    // Add loading state
    this.classList.add('loading');
    
    // Small delay to show the loading state
    setTimeout(() => {
      // If only one collection is selected, navigate to that collection page
      if (selectedCollections.length === 1) {
        const collectionHandle = selectedCollections[0];
        window.location.href = `/collections/${collectionHandle}`;
        return;
      }
      
      // If multiple collections selected, show all products from those collections
      if (selectedCollections.length > 1) {
        // For multiple collections, we'll use search with collection tags
        const url = new URL('/search', window.location.origin);
        url.searchParams.set('q', selectedCollections.map(c => `collection:${c}`).join(' OR '));
        window.location.href = url.toString();
        return;
      }
      
      // If no collections selected, go to all products
      if (selectedCollections.length === 0) {
        window.location.href = '/collections/all';
        return;
      }
    }, 100);
  }
}

customElements.define('collection-filter-component', CollectionFilterComponent);
